module.exports = __webpack_public_path__ + "img/banner-alaska2.9dfe4d47.png";